// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.acc-dialog-title {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 600;
}

.acc-dialog-content {
  padding-top: 8px !important;
  min-width: min(400px, 85vw);
}

.acc-dialog-lead {
  margin: 0 0 16px;
  font-size: 0.875rem;
  line-height: 1.45;
  color: rgba(0, 0, 0, 0.65);
}

.acc-option {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 14px;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 10px;
  margin-bottom: 10px;
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease;
}
.acc-option:hover {
  background: rgba(0, 0, 0, 0.03);
}
.acc-option--selected {
  border-color: #0b6397;
  background: rgba(11, 99, 151, 0.06);
}

.acc-option__icon {
  flex-shrink: 0;
}

.acc-option__text {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.acc-option__label {
  font-weight: 500;
  font-size: 0.9375rem;
}

.acc-option__hint {
  font-size: 0.75rem;
  color: rgba(0, 0, 0, 0.55);
}

.acc-option__check {
  flex-shrink: 0;
  color: #0b6397;
  font-size: 22px;
  width: 22px;
  height: 22px;
}

.acc-dialog-actions {
  padding: 8px 0 0 !important;
  margin-bottom: 0 !important;
  display: flex !important;
  justify-content: flex-end !important;
  align-items: center !important;
  gap: 12px !important;
}
.acc-dialog-actions .btn-primary,
.acc-dialog-actions .btn-secondary {
  padding: 12px 24px !important;
  border-radius: 8px !important;
  font-size: 14px !important;
  font-weight: 500 !important;
  font-family: "Raleway" !important;
  min-width: 100px !important;
  height: 44px !important;
  line-height: 1.2 !important;
  text-transform: none !important;
  letter-spacing: normal !important;
  border: none !important;
  transition: all 0.2s ease !important;
}
.acc-dialog-actions .btn-primary {
  background: #5ea1d8 !important;
  color: #fff !important;
}
.acc-dialog-actions .btn-primary:hover {
  background: #4a8fc4 !important;
}
.acc-dialog-actions .btn-secondary {
  background: #f3f4f6 !important;
  color: #374151 !important;
}
.acc-dialog-actions .btn-secondary:hover {
  background: #e5e7eb !important;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/add-consultation-calendar-dialog/add-consultation-calendar-dialog.component.scss"],"names":[],"mappings":"AAAA;EACE,SAAA;EACA,kBAAA;EACA,gBAAA;AACF;;AAEA;EACE,2BAAA;EACA,2BAAA;AACF;;AAEA;EACE,gBAAA;EACA,mBAAA;EACA,iBAAA;EACA,0BAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;EACA,qCAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,0DAAA;AACF;AACE;EACE,+BAAA;AACJ;AAEE;EACE,qBAAA;EACA,mCAAA;AAAJ;;AAIA;EACE,cAAA;AADF;;AAIA;EACE,OAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AADF;;AAIA;EACE,gBAAA;EACA,oBAAA;AADF;;AAIA;EACE,kBAAA;EACA,0BAAA;AADF;;AAIA;EACE,cAAA;EACA,cAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;AADF;;AAIA;EACE,2BAAA;EACA,2BAAA;EACA,wBAAA;EACA,oCAAA;EACA,8BAAA;EACA,oBAAA;AADF;AAGE;;EAEE,6BAAA;EACA,6BAAA;EACA,0BAAA;EACA,2BAAA;EACA,iCAAA;EACA,2BAAA;EACA,uBAAA;EACA,2BAAA;EACA,+BAAA;EACA,iCAAA;EACA,uBAAA;EACA,oCAAA;AADJ;AAIE;EACE,8BAAA;EACA,sBAAA;AAFJ;AAII;EACE,8BAAA;AAFN;AAME;EACE,8BAAA;EACA,yBAAA;AAJJ;AAMI;EACE,8BAAA;AAJN","sourcesContent":[".acc-dialog-title {\n  margin: 0;\n  font-size: 1.25rem;\n  font-weight: 600;\n}\n\n.acc-dialog-content {\n  padding-top: 8px !important;\n  min-width: min(400px, 85vw);\n}\n\n.acc-dialog-lead {\n  margin: 0 0 16px;\n  font-size: 0.875rem;\n  line-height: 1.45;\n  color: rgba(0, 0, 0, 0.65);\n}\n\n.acc-option {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 14px;\n  border: 1px solid rgba(0, 0, 0, 0.12);\n  border-radius: 10px;\n  margin-bottom: 10px;\n  cursor: pointer;\n  transition: border-color 0.15s ease, background 0.15s ease;\n\n  &:hover {\n    background: rgba(0, 0, 0, 0.03);\n  }\n\n  &--selected {\n    border-color: #0b6397;\n    background: rgba(11, 99, 151, 0.06);\n  }\n}\n\n.acc-option__icon {\n  flex-shrink: 0;\n}\n\n.acc-option__text {\n  flex: 1;\n  min-width: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.acc-option__label {\n  font-weight: 500;\n  font-size: 0.9375rem;\n}\n\n.acc-option__hint {\n  font-size: 0.75rem;\n  color: rgba(0, 0, 0, 0.55);\n}\n\n.acc-option__check {\n  flex-shrink: 0;\n  color: #0b6397;\n  font-size: 22px;\n  width: 22px;\n  height: 22px;\n}\n\n.acc-dialog-actions {\n  padding: 8px 0 0 !important;\n  margin-bottom: 0 !important;\n  display: flex !important;\n  justify-content: flex-end !important;\n  align-items: center !important;\n  gap: 12px !important;\n\n  .btn-primary,\n  .btn-secondary {\n    padding: 12px 24px !important;\n    border-radius: 8px !important;\n    font-size: 14px !important;\n    font-weight: 500 !important;\n    font-family: \"Raleway\" !important;\n    min-width: 100px !important;\n    height: 44px !important;\n    line-height: 1.2 !important;\n    text-transform: none !important;\n    letter-spacing: normal !important;\n    border: none !important;\n    transition: all 0.2s ease !important;\n  }\n\n  .btn-primary {\n    background: #5ea1d8 !important;\n    color: #fff !important;\n\n    &:hover {\n      background: #4a8fc4 !important;\n    }\n  }\n\n  .btn-secondary {\n    background: #f3f4f6 !important;\n    color: #374151 !important;\n\n    &:hover {\n      background: #e5e7eb !important;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
